import {
  borderWidths,
  colors,
  media,
  new_typography as typography,
  radius,
  spacing,
} from '@lamimed/pantheon';
import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: ${spacing.xxlarge} 0 0 0;

  // TODO: Add to pantheon
  strong {
    font-weight: bold;
  }
`;

export const List = styled.ul`
  margin-left: ${spacing.medium};
`;

export const Item = styled.li`
  ${typography.body_text_2};
  color: ${colors.text__primary};
`;

const tableColumnWidth = '30rem';

export const TableWrapper = styled.div`
  overflow-x: auto;

  table {
    width: 100%;
    min-width: calc(${tableColumnWidth} * 3);
    border-radius: ${radius.medium};
    overflow: hidden;
    border: ${borderWidths.thin} solid ${colors.neutral_light};
    border-spacing: 0;
    border-collapse: separate;

    ${media.greaterThan('tablet')`
      min-width: ${tableColumnWidth};
    `}

    th,
    td {
      padding: ${spacing.medium};
    }

    td:first-letter,
    th::first-letter {
      text-transform: capitalize;
    }

    tr:last-of-type {
      td {
        border-bottom: 0;
      }
    }

    td {
      border-bottom: ${borderWidths.thin} solid ${colors.neutral_light};
    }

    thead {
      color: ${colors.light};
      background-color: ${colors.secondary};

      th {
        ${typography.body_text_1};
        font-weight: 600;
        text-align: left;
      }
    }

    tbody {
      color: ${colors.text__primary};

      td {
        width: ${tableColumnWidth};
        font-size: 1.2rem;

        ${media.greaterThan('tablet')`
          ${typography.body_text_2}
        `}
      }
    }
  }
`;
